import { arrayOf, bool, func, node, oneOf, oneOfType } from 'prop-types'
import { type ReactNode, useMemo, type VFC } from 'react'

import { type Tenant as TenantType } from 'types/shopConfig'
import { ACTIVE_TENANTS } from 'views/consts/tenants'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

type TenantProps = {
  children: ReactNode | (() => ReactNode)
  not?: boolean
  tenant: TenantType | TenantType[]
}

const Tenant: VFC<TenantProps> = ({ children, not, tenant }) => {
  const { tenant: currentTenant } = usePublicConfig()

  const tenants: TenantType[] = useMemo(
    () => (Array.isArray(tenant) ? tenant : [tenant]),
    [tenant]
  )

  if (tenants.includes(currentTenant) === not) {
    return null
  }

  return typeof children === 'function' ? children() : children
}

Tenant.propTypes = {
  children: oneOfType([func, node]).isRequired,
  not: bool,
  tenant: oneOfType([arrayOf(oneOf(ACTIVE_TENANTS)), oneOf(ACTIVE_TENANTS)])
    .isRequired,
}

Tenant.defaultProps = {
  not: false,
}

export default Tenant
